import * as Enum from '@/const';
import * as OM from '@/model';
import moment from 'moment';
import store from './store';
import CodiceFiscale from 'codice-fiscale-js';

export function JsonClone(item){
    return JSON.parse(JSON.stringify(item));
}

export function getQueryParams(url?) {
    if(!url){
        url = window.location.href;
    }
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    paramArr.map(param => {
        const [key, val] = param.split('=');
        params[key] = decodeURIComponent(val);
    })
    return params;
}

export function getInizioTrimestre(mese: number){
    mese += 1;
    let currentYear = new Date().getFullYear().toString();
    if(mese >= 1 && mese <= 3){
        return moment(`${currentYear}-01-1`);
    } else if(mese >= 4 && mese <= 6) {
        return moment(`${currentYear}-04-1`);
    } else if(mese >= 7 && mese <= 9) {
        return moment(`${currentYear}-07-1`);
    } else if(mese >= 10 && mese <= 12)  {
        return moment(`${currentYear}-10-1`);
    }
}

export function getFineTrimestre(mese: number){
    mese += 1;
    let currentYear = new Date().getFullYear().toString();
    if(mese >= 1 && mese <= 3){
        return moment(`${currentYear}-01-01`).add(3, 'months').subtract(1,'second');
    } else if(mese >= 4 && mese <= 6) {
        return moment(`${currentYear}-04-01`).add(3, 'months').subtract(1,'second');
    } else if(mese >= 7 && mese <= 9) {
        return moment(`${currentYear}-07-01`).add(3, 'months').subtract(1,'second');
    } else if(mese >= 10 && mese <= 12)  {
        return moment(`${currentYear}-10-01`).add(3, 'months').subtract(1,'second');
    }
}

export function checkIfAddressCompleted(input: OM.Address){
    return input && 
        input.citta &&
        input.provincia &&
        input.cap &&
        input.via &&
        input.civico &&
        input.nazione
}

type Gender = "F" | "M";
export function CalcolaCodFisc(name: string, surname: string, gender: Gender, day: number, month: number, year: number, birthplace, birthplaceProvincia){
    let cf = new CodiceFiscale({
        name: name,
        surname: surname,
        gender: gender,
        day: day,
        month: month,
        year: year,
        birthplace: birthplace,
        birthplaceProvincia: birthplaceProvincia
    });
    return cf;
}

export function CodFiscInverso(input: string){
    return CodiceFiscale.computeInverse(input);
}


export function checkFiscalDataCompleted(user: OM.BaseUser){
    let res: any = true;
    
    res = res &&
        user.personalData.country;

    let needsFiscalCode = false;
    if(user.personalData.country == "Italy")
        needsFiscalCode = true;

    if(needsFiscalCode)
        res = res && user.fiscalData.fiscalCode

    res = res &&
        user.fiscalData.birthDate &&
        user.fiscalData.birthPlace;

    res = res && 
        user.fiscalData.fiscalAddress.citta &&
        user.fiscalData.fiscalAddress.provincia &&
        user.fiscalData.fiscalAddress.cap &&
        user.fiscalData.fiscalAddress.via &&
        user.fiscalData.fiscalAddress.civico &&
        user.fiscalData.fiscalAddress.nazione;

    return !!res;
}

export function checkIfRichiestaPagamentoPossible(user: OM.BaseUser, needsFiscalCode: boolean){
    let res: any = true;
    if(needsFiscalCode){
        res = res && user.fiscalData.fiscalCode && 
            user.fiscalData.birthDate &&
            user.fiscalData.birthPlace;
    }
    res = res && 
        user.fiscalData.fiscalAddress.citta &&
        user.fiscalData.fiscalAddress.provincia &&
        user.fiscalData.fiscalAddress.cap &&
        user.fiscalData.fiscalAddress.via &&
        user.fiscalData.fiscalAddress.civico &&
        user.fiscalData.fiscalAddress.nazione

    return !!res;
}

export function copyToClipboard(text) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}